module.exports = __webpack_public_path__ + "img/wuyidaxue.7e138d51.jpg";